/*
 * @Author: your name
 * @Date: 2020-12-07 18:02:15
 * @LastEditTime: 2020-12-09 20:37:16
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /shopManagement/src/service/basic/exceptionApiList.js
 */
const r4InvoiceApiList = {
  getUnInvoiceList: '/settle-center/diablo/un-invoice', // 待开票列表
  getInvoiceList: '/settle-center/diablo/invoice-list', // 已开票列表
  getInvoiceItemList: '/settle-center/diablo/page/invoice-item', // 已开票明细列表
  getInvoiceImage: '/settle-center/invoice/image', // 查看发票
  getSettleItemList: '/pay/account/list/detail', // 结算单明细
  getInvoiceItemInfo: '/settle-center/diablo/invoice-item', // 开票明细
  getDeliveryImage: '/settle-center/delivery/image', // 查看快递图片
  getImage: '/settle-center/batch/image', //批量上传图片
  getInvoice: '/settle-center/diablo/invoice', //生成发票
  exportUnInvoice: '/settle-center/diablo/export/un-invoice', //待开票明细导出
  exportInvoice: '/settle-center/diablo/export/invoice', //已开票明细导出
  exportInvoiceItem: '/settle-center/settle/diablo/export-item', //已开票结算单明细导出
}
export default r4InvoiceApiList



// WEBPACK FOOTER //
// ./src/service/basic/r4InvoiceApiList.js